import "./switch.scss";

import * as React from "react";
import { getValue } from "@utils/lodash";

interface IEntitySwitchProps {
	is_active: boolean;
	onChange: (
		e: any,
		status: boolean,
		id: any,
		parent_id: any,
		parent_index: any
	) => void;
	id: string;
	parent_id: any;
	parent_index: any;
}

const EntitySwitch: React.FunctionComponent<IEntitySwitchProps> = (props) => {
	return (
		<div className="choicelist-wrapper custom-switch-wrapper">
			<label className="switch">
				<input
					type="checkbox"
					checked={getValue(props, `is_active`, false)}
					onChange={(e) =>
						props.onChange(
							e,
							getValue(props, `id`, ""),
							!getValue(props, `is_active`, ""),
							getValue(props, `parent_id`, ""),
							getValue(props, `parent_index`, "")
						)
					}
				/>
				<span className="slider round"></span>
			</label>
		</div>
	);
};

export default EntitySwitch;
